import { GOOGLE_OAUTH_ENDPOINT } from "../../constants";
import { FcGoogle } from "react-icons/fc";
import clsx from "clsx";

export function GoogleButton() {
  const handleClick = () => {
    const width = 600;
    const height = 700;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    window.open(
      GOOGLE_OAUTH_ENDPOINT,
      "googleOAuth",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  };

  const baseClasses = clsx(
    "flex items-center justify-center w-full gap-3 rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-900 shadow-sm transition-all duration-200",
    "hover:shadow-md hover:bg-gray-50 hover:scale-[1.02] active:scale-[0.98]"
  );

  return (
    <button onClick={handleClick} type="button" className={baseClasses}>
      <FcGoogle className="w-6 h-6" />
      <span>Continue with Google</span>
    </button>
  );
}